"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ethEnsNamehash = _interopRequireDefault(require("eth-ens-namehash"));

var _contract = _interopRequireDefault(require("./contract"));

var _ensResolver = _interopRequireDefault(require("./ensResolver"));

var _ENS = _interopRequireDefault([{
  inputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor",
  signature: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "node",
    type: "bytes32"
  }, {
    indexed: true,
    name: "label",
    type: "bytes32"
  }, {
    indexed: false,
    name: "owner",
    type: "address"
  }],
  name: "NewOwner",
  type: "event",
  signature: "0xce0457fe73731f824cc272376169235128c118b49d344817417c6d108d155e82"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    name: "owner",
    type: "address"
  }],
  name: "Transfer",
  type: "event",
  signature: "0xd4735d920b0f87494915f556dd9b54c8f309026070caea5c737245152564d266"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    name: "resolver",
    type: "address"
  }],
  name: "NewResolver",
  type: "event",
  signature: "0x335721b01866dc23fbee8b6b2c7b1e14d6f05c28cd35a2c934239f94095602a0"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "node",
    type: "bytes32"
  }, {
    indexed: false,
    name: "ttl",
    type: "uint64"
  }],
  name: "NewTTL",
  type: "event",
  signature: "0x1d4f9bbfc9cab89d66e1a1562f2233ccbf1308cb4f63de2ead5787adddb8fa68"
}, {
  constant: true,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }],
  name: "owner",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x02571be3"
}, {
  constant: true,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }],
  name: "resolver",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x0178b8bf"
}, {
  constant: true,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }],
  name: "ttl",
  outputs: [{
    name: "",
    type: "uint64"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x16a25cbd"
}, {
  constant: false,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_owner",
    type: "address"
  }],
  name: "setOwner",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x5b0fc9c3"
}, {
  constant: false,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_label",
    type: "bytes32"
  }, {
    name: "_owner",
    type: "address"
  }],
  name: "setSubnodeOwner",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x06ab5923"
}, {
  constant: false,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_resolver",
    type: "address"
  }],
  name: "setResolver",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x1896f70a"
}, {
  constant: false,
  inputs: [{
    name: "_node",
    type: "bytes32"
  }, {
    name: "_ttl",
    type: "uint64"
  }],
  name: "setTTL",
  outputs: [],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x14ab9038"
}]);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Ens = /*#__PURE__*/function (_Contract) {
  _inherits(Ens, _Contract);

  var _super = _createSuper(Ens);

  function Ens(web3, address, version) {
    var _this;

    var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "eth";

    _classCallCheck(this, Ens);

    _this = _super.call(this, web3, _ENS["default"], address);
    _this.version = version;
    _this.suffix = suffix;
    _this.resolver = null;

    _this.getResolver().then(function (r) {
      return _this.setResolver(r);
    });

    return _this;
  }

  _createClass(Ens, [{
    key: "getResolver",
    value: function getResolver() {
      return this.methods.resolver(_ethEnsNamehash["default"].hash(this.version + ".robonomics." + this.suffix)).call();
    }
  }, {
    key: "setResolver",
    value: function setResolver(resolver) {
      this.resolver = new _ensResolver["default"](this.web3, resolver);
    }
  }, {
    key: "getUrlZone",
    value: function getUrlZone(name) {
      var zone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var url = name;

      if (zone && new RegExp("." + zone).test(name) === false) {
        url += "." + zone;
      }

      return url;
    }
  }, {
    key: "getUrl",
    value: function getUrl(name) {
      var zone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var url = this.getUrlZone(name, zone);

      if (new RegExp("." + this.suffix).test(name)) {
        return url;
      }

      if (new RegExp(".robonomics." + this.suffix).test(name) === false) {
        url += "." + this.version + ".robonomics." + this.suffix;
      }

      return url;
    }
  }, {
    key: "addr",
    value: function () {
      var _addr = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.resolver === null)) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = this;
                _context.next = 4;
                return this.getResolver();

              case 4:
                _context.t1 = _context.sent;

                _context.t0.setResolver.call(_context.t0, _context.t1);

              case 6:
                return _context.abrupt("return", this.resolver.addr(this.getUrl(name)));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addr(_x) {
        return _addr.apply(this, arguments);
      }

      return addr;
    }()
  }, {
    key: "addrLighthouse",
    value: function addrLighthouse(name) {
      return this.addr(this.getUrlZone(name, "lighthouse"));
    }
  }, {
    key: "addrModel",
    value: function addrModel(name) {
      return this.addr(this.getUrlZone(name, "model"));
    }
  }, {
    key: "addrValidator",
    value: function addrValidator(name) {
      return this.addr(this.getUrlZone(name, "validator"));
    }
  }]);

  return Ens;
}(_contract["default"]);

exports["default"] = Ens;